<div class="business-detail-container" *ngIf="business">

  <!-- Cover image / gradient fallback -->
  <div class="cover-section" [style.backgroundImage]="business.coverImage ? 'url(' + resolveImg(business.coverImage) + ')' : ''">
    <div class="cover-overlay">
      <button class="btn-back" (click)="goBack()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="22" height="22">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button>
      <div class="cover-badge" [class.open]="business.isOpen">
        {{ business.isOpen ? 'Abierto' : 'Cerrado' }}
      </div>
    </div>
  </div>

  <!-- Logo + Name -->
  <div class="business-header">
    <div class="logo-wrapper">
      <div class="logo-placeholder" *ngIf="!business.logoImage">
        {{ business.name[0] }}
      </div>
      <img *ngIf="business.logoImage" [src]="resolveImg(business.logoImage)" [alt]="business.name" class="logo-img">
    </div>
    <div class="header-info">
      <h1 class="business-name">{{ business.name }}</h1>
      <div class="business-meta" *ngIf="business.cuisineType || business.priceRange || business.rating">
        <span class="cuisine" *ngIf="business.cuisineType">{{ business.cuisineType }}</span>
        <span class="price" *ngIf="business.priceRange">{{ business.priceRange }}</span>
        <span class="rating" *ngIf="business.rating">
          {{ business.rating | number:'1.1-1' }}
          <small>({{ business.reviewCount }})</small>
        </span>
      </div>
      <p class="business-address" *ngIf="business.address">{{ business.address }}</p>
    </div>
  </div>

  <!-- Service capabilities (dynamic) -->
  <div class="services-section" *ngIf="serviceChips.length > 0">
    <div class="services-grid" [class.cols-2]="serviceChips.length === 2" [class.cols-3]="serviceChips.length === 3" [class.cols-4]="serviceChips.length >= 4">
      <button *ngFor="let chip of serviceChips"
              class="service-action-card"
              (click)="onServiceChipClick(chip)">
        <span class="service-icon">{{ chip.icon }}</span>
        <span class="service-label">{{ chip.label }}</span>
      </button>
    </div>
  </div>

  <!-- Quick utility actions (always visible) -->
  <div class="utility-actions">
    <button class="utility-btn" (click)="callBusiness()" *ngIf="business.phone">
      <span class="utility-icon">📞</span>
      <span class="utility-label">Llamar</span>
    </button>
    <button class="utility-btn" (click)="getDirections()" *ngIf="business.address">
      <span class="utility-icon">🗺️</span>
      <span class="utility-label">Llegar</span>
    </button>
  </div>

  <!-- No services message -->
  <div class="no-services-msg" *ngIf="serviceChips.length === 0 && !loading">
    <p>Este negocio aun no tiene servicios activos en BarClik.</p>
  </div>

  <!-- Menu preview (categories from cache) -->
  <div class="menus-section" *ngIf="menuAvailable && menuCategories.length > 0">
    <div class="menus-header">
      <h3 class="menus-title">Carta</h3>
      <span class="menu-product-count" *ngIf="menuProducts.length > 0">{{ menuProducts.length }} productos</span>
    </div>
    <div class="menu-categories-preview">
      <span class="cat-chip" *ngFor="let cat of menuCategories">{{ cat.name }}</span>
    </div>
  </div>

  <!-- Loading menu -->
  <div class="section-card loading-card" *ngIf="loadingMenu">
    <div class="loading-inline">
      <div class="spinner-sm"></div>
      <span>Cargando carta...</span>
    </div>
  </div>

  <!-- Menu error -->
  <div class="section-card error-card" *ngIf="menuError">
    <p class="error-text">{{ menuError }}</p>
  </div>

  <!-- Description -->
  <div class="section-card" *ngIf="business.description">
    <h3 class="section-title">Sobre este local</h3>
    <p class="description-text">{{ business.description }}</p>
  </div>

  <!-- Promotions -->
  <div class="section-card" *ngIf="business.specialOffers && business.specialOffers.length > 0">
    <h3 class="section-title">Promociones</h3>
    <div class="promo-list">
      <div *ngFor="let offer of business.specialOffers" class="promo-item">
        <span class="promo-icon">🎁</span>
        <span class="promo-text">{{ offer }}</span>
      </div>
    </div>
  </div>

  <!-- Hours -->
  <div class="section-card" *ngIf="business.hours">
    <h3 class="section-title">Horario</h3>
    <p class="hours-text">{{ business.hours }}</p>
  </div>

  <!-- Feedback actions -->
  <div class="section-card">
    <h3 class="section-title">Tu opinion</h3>
    <div class="feedback-actions">
      <button class="feedback-btn" (click)="openFeedback('suggestion')">
        <span class="fb-icon">💡</span>
        <span>Sugerencia</span>
      </button>
      <button class="feedback-btn" (click)="openFeedback('complaint')">
        <span class="fb-icon">📝</span>
        <span>Queja</span>
      </button>
      <button class="feedback-btn" (click)="openFeedback('review')">
        <span class="fb-icon">⭐</span>
        <span>Resena</span>
      </button>
    </div>
  </div>

</div>

<div class="loading-state" *ngIf="loading">
  <div class="spinner"></div>
  <p>Cargando local...</p>
</div>

<!-- Feedback Modal -->
<div class="reservation-overlay" *ngIf="showFeedbackModal" (click)="closeFeedbackModal()"></div>
<div class="reservation-modal" *ngIf="showFeedbackModal">
  <div class="modal-header">
    <h3>{{ feedbackTypeLabel }}</h3>
    <button class="modal-close" (click)="closeFeedbackModal()">&#10005;</button>
  </div>
  <div class="modal-body">
    <!-- Success -->
    <div *ngIf="feedbackSuccess" class="step-content success-step">
      <div class="success-icon">&#10003;</div>
      <h4>Enviado</h4>
      <p>Tu {{ feedbackTypeLabel | lowercase }} ha sido enviada a {{ business?.name }}. Gracias.</p>
      <button class="btn-step-next" (click)="closeFeedbackModal()">Cerrar</button>
    </div>

    <!-- Form -->
    <div *ngIf="!feedbackSuccess" class="step-content">
      <!-- Rating stars (only for reviews) -->
      <div class="form-group" *ngIf="feedbackType === 'review'">
        <label>Valoracion *</label>
        <div class="star-rating">
          <button *ngFor="let s of [1,2,3,4,5]"
            class="star-btn" [class.active]="s <= feedbackRating"
            (click)="setFeedbackRating(s)">&#9733;</button>
        </div>
      </div>

      <div class="form-group">
        <label>Titulo *</label>
        <input type="text" [(ngModel)]="feedbackTitle" placeholder="Resumen breve..." class="text-input" maxlength="200" />
      </div>

      <div class="form-group">
        <label>Descripcion *</label>
        <textarea [(ngModel)]="feedbackContent" placeholder="Cuenta tu experiencia..." class="notes-input" rows="4"></textarea>
      </div>

      <!-- Category ratings (only for reviews) -->
      <div *ngIf="feedbackType === 'review'" class="category-ratings">
        <div class="cat-row">
          <span>Comida</span>
          <div class="mini-stars">
            <button *ngFor="let s of [1,2,3,4,5]" class="mini-star" [class.active]="s <= feedbackCategoryFood" (click)="feedbackCategoryFood = s">&#9733;</button>
          </div>
        </div>
        <div class="cat-row">
          <span>Servicio</span>
          <div class="mini-stars">
            <button *ngFor="let s of [1,2,3,4,5]" class="mini-star" [class.active]="s <= feedbackCategoryService" (click)="feedbackCategoryService = s">&#9733;</button>
          </div>
        </div>
        <div class="cat-row">
          <span>Ambiente</span>
          <div class="mini-stars">
            <button *ngFor="let s of [1,2,3,4,5]" class="mini-star" [class.active]="s <= feedbackCategoryAmbience" (click)="feedbackCategoryAmbience = s">&#9733;</button>
          </div>
        </div>
        <div class="cat-row">
          <span>Precio</span>
          <div class="mini-stars">
            <button *ngFor="let s of [1,2,3,4,5]" class="mini-star" [class.active]="s <= feedbackCategoryValue" (click)="feedbackCategoryValue = s">&#9733;</button>
          </div>
        </div>
      </div>

      <div class="reservation-error" *ngIf="feedbackError">{{ feedbackError }}</div>

      <button
        class="btn-confirm-reservation"
        [disabled]="!isFeedbackValid || submittingFeedback"
        (click)="submitFeedback()">
        <span *ngIf="!submittingFeedback">Enviar {{ feedbackTypeLabel | lowercase }}</span>
        <span *ngIf="submittingFeedback" class="spinner-inline"></span>
      </button>
    </div>
  </div>
</div>

<!-- Order Mode Modal (Takeaway / Delivery) -->
<div class="reservation-overlay" *ngIf="showOrderModal" (click)="closeOrderModal()"></div>
<div class="reservation-modal order-mode-modal" *ngIf="showOrderModal">
  <div class="modal-header">
    <h3>{{ orderModalMode === 'delivery' ? '🛵 Delivery' : '🥡 Recoger' }}</h3>
    <button class="modal-close" (click)="closeOrderModal()">&#10005;</button>
  </div>
  <div class="modal-body">
    <div class="step-content">
      <label class="step-label">Datos de {{ orderModalMode === 'delivery' ? 'entrega' : 'recogida' }}</label>

      <div class="form-group">
        <label>Nombre *</label>
        <input type="text" [(ngModel)]="orderCustomerName" placeholder="Tu nombre" class="text-input" />
      </div>

      <div class="form-group">
        <label>Telefono *</label>
        <input type="tel" [(ngModel)]="orderCustomerPhone" placeholder="+34 600 000 000" class="text-input" />
      </div>

      <div class="form-group" *ngIf="orderModalMode === 'delivery'">
        <label>Direccion de entrega *</label>
        <div class="address-toggle" *ngIf="profileAddress">
          <button class="toggle-btn" [class.active]="orderUseProfileAddress" (click)="onToggleProfileAddress()">
            Usar direccion del perfil
          </button>
        </div>
        <input
          type="text"
          [(ngModel)]="orderCustomerAddress"
          placeholder="Calle, numero, piso..."
          class="text-input"
          [readonly]="orderUseProfileAddress && !!profileAddress"
        />
        <button *ngIf="orderUseProfileAddress && profileAddress" class="btn-change-address" (click)="onToggleProfileAddress()">
          Cambiar direccion
        </button>
      </div>

      <button
        class="btn-confirm-reservation"
        [disabled]="!isOrderFormValid"
        (click)="confirmOrderMode()">
        Continuar al menu
      </button>
    </div>
  </div>
</div>

<!-- Reservation Modal -->
<div class="reservation-overlay" *ngIf="showReservationModal" (click)="closeReservationModal()"></div>
<div class="reservation-modal" *ngIf="showReservationModal">
  <div class="modal-header">
    <button class="modal-back" *ngIf="reservationStep !== 'date' && reservationStep !== 'success'" (click)="reservationStepBack()">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="15 18 9 12 15 6"/>
      </svg>
    </button>
    <h3>{{ bookingModeLabel }} en {{ business?.name }}</h3>
    <button class="modal-close" (click)="closeReservationModal()">&#10005;</button>
  </div>

  <div class="modal-body">
    <!-- Step: Service (appointment/service modes) -->
    <div *ngIf="reservationStep === 'service'" class="step-content">
      <label class="step-label">Elige un servicio</label>

      <div *ngIf="loadingServices" class="loading-inline">
        <span class="spinner-inline"></span>
        <span>Cargando servicios...</span>
      </div>

      <div *ngIf="!loadingServices && services.length > 0" class="services-list">
        <button
          *ngFor="let svc of services"
          class="service-option"
          [class.selected]="selectedServiceId === svc.id"
          (click)="selectService(svc.id)">
          <span class="svc-name">{{ svc.name }}</span>
          <span class="svc-meta" *ngIf="svc.duration_minutes || svc.price">
            <span *ngIf="svc.duration_minutes">{{ svc.duration_minutes }} min</span>
            <span *ngIf="svc.price"> - {{ svc.price | number:'1.2-2' }} EUR</span>
          </span>
        </button>
      </div>

      <div *ngIf="!loadingServices && services.length === 0" class="no-services-hint">
        <p>No hay servicios disponibles. Puedes continuar sin seleccionar.</p>
      </div>

      <!-- Professional selection (appointment mode) -->
      <div *ngIf="professionals.length > 0" class="professionals-section">
        <label class="step-label">Profesional (opcional)</label>
        <div class="professionals-list">
          <button
            class="professional-option"
            [class.selected]="selectedProfessionalId === null"
            (click)="selectProfessional(null)">
            Sin preferencia
          </button>
          <button
            *ngFor="let pro of professionals"
            class="professional-option"
            [class.selected]="selectedProfessionalId === pro.id"
            (click)="selectProfessional(pro.id)">
            {{ pro.name }}
          </button>
        </div>
      </div>

      <button
        class="btn-step-next"
        (click)="proceedFromService()">
        Continuar
      </button>
    </div>

    <!-- Step: Date -->
    <div *ngIf="reservationStep === 'date'" class="step-content">
      <label class="step-label">Selecciona fecha</label>
      <input
        type="date"
        [(ngModel)]="reservationDate"
        [min]="minDate"
        class="date-input"
      />
      <p class="advance-hint">Las horas con menos de 2h de antelacion no estaran disponibles</p>
      <button
        class="btn-step-next"
        [disabled]="!reservationDate || loadingSlots"
        (click)="loadAvailability()">
        <span *ngIf="!loadingSlots">Ver disponibilidad</span>
        <span *ngIf="loadingSlots" class="spinner-inline"></span>
      </button>
    </div>

    <!-- Step: Time -->
    <div *ngIf="reservationStep === 'time'" class="step-content">
      <label class="step-label">Elige hora - {{ reservationDate }}</label>
      <div class="time-slots-grid" *ngIf="timeSlots.length > 0">
        <button
          *ngFor="let slot of timeSlots"
          class="time-slot"
          [class.available]="slot.available"
          [class.selected]="selectedSlot === slot"
          [disabled]="!slot.available"
          (click)="selectTimeSlot(slot)">
          {{ slot.slot_start }}
        </button>
      </div>
      <p class="no-slots" *ngIf="timeSlots.length === 0 && !loadingSlots">
        No hay horarios disponibles para esta fecha
      </p>
    </div>

    <!-- Step: Details -->
    <div *ngIf="reservationStep === 'details'" class="step-content">
      <label class="step-label">Detalles de la reserva</label>

      <div class="form-group">
        <label>Personas</label>
        <div class="party-size-control">
          <button (click)="partySize = partySize > 1 ? partySize - 1 : 1" class="qty-btn">-</button>
          <span class="party-size">{{ partySize }}</span>
          <button (click)="partySize = partySize + 1" class="qty-btn">+</button>
        </div>
      </div>

      <div class="form-group">
        <label>Notas (opcional)</label>
        <textarea
          [(ngModel)]="reservationNotes"
          placeholder="Mesa ventana, silla bebe, alergias..."
          class="notes-input"
          rows="3"
        ></textarea>
      </div>

      <button class="btn-step-next" (click)="goToConfirmReservation()">
        Continuar
      </button>
    </div>

    <!-- Step: Confirm -->
    <div *ngIf="reservationStep === 'confirm'" class="step-content">
      <label class="step-label">Confirmar reserva</label>

      <div class="reservation-summary">
        <div class="summary-row"><span>Fecha:</span><strong>{{ reservationDate }}</strong></div>
        <div class="summary-row"><span>Hora:</span><strong>{{ selectedSlot?.slot_start }} - {{ selectedSlot?.slot_end }}</strong></div>
        <div class="summary-row"><span>Personas:</span><strong>{{ partySize }}</strong></div>
        <div class="summary-row" *ngIf="reservationNotes"><span>Notas:</span><span>{{ reservationNotes }}</span></div>
      </div>

      <div class="form-group">
        <label>Nombre *</label>
        <input
          type="text"
          [(ngModel)]="customerName"
          placeholder="Tu nombre"
          class="text-input"
        />
      </div>

      <div class="form-group">
        <label>Telefono (opcional)</label>
        <input
          type="tel"
          [(ngModel)]="customerPhone"
          placeholder="+34 600 123 456"
          class="text-input"
        />
      </div>

      <button
        class="btn-confirm-reservation"
        [disabled]="submittingReservation || !customerName.trim()"
        (click)="submitReservation()">
        <span *ngIf="!submittingReservation">Confirmar Reserva</span>
        <span *ngIf="submittingReservation" class="spinner-inline"></span>
      </button>
    </div>

    <!-- Step: Success (pending confirmation) -->
    <div *ngIf="reservationStep === 'success'" class="step-content success-step">
      <div class="success-icon pending-icon">&#9200;</div>
      <h4>{{ bookingModeLabel }} pendiente de confirmacion</h4>
      <p>Tu solicitud ha sido enviada a <strong>{{ business?.name }}</strong>.</p>
      <p class="pending-info">El comercio la revisara y te confirmara en horario laboral.</p>
      <p class="pending-estimate">Tiempo estimado de respuesta: <strong>2-4 horas</strong> en horario de apertura.</p>
      <p class="pending-hint">Recibiras una notificacion cuando sea confirmada o rechazada.</p>
      <button class="btn-step-next" (click)="closeReservationModal()">Entendido</button>
    </div>

    <!-- Error -->
    <div class="reservation-error" *ngIf="reservationError">
      {{ reservationError }}
    </div>
  </div>
</div>
